module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_long_blonde.11a1e0d3.png";